import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnotaButtonModule, AnotaModalModule } from '@githubanotaai/design-system';

export interface MiddlewareExitIntentModalVariant {
  title: string;
  subtitle: string;
  ctaText: string;
  imageSrc?: string;
}

@Component({
  selector: 'app-middleware-exit-intent-modal',
  standalone: true,
  imports: [CommonModule, AnotaButtonModule, AnotaModalModule],
  templateUrl: './exit-intent-modal.component.html',
  styleUrl: './exit-intent-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiddlewareExitIntentModalComponent {
  @Input() visible = false;
  @Input() variant: 'variantA' | 'variantB' = 'variantA';
  @Input() dealId?: string | {};
  
  @Output() onAccept = new EventEmitter<void>();
  @Output() onDismiss = new EventEmitter<void>();
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) {}

  protected readonly variants: Record<'variantA' | 'variantB', MiddlewareExitIntentModalVariant> = {
    variantA: {
      title: 'Sua loja vendendo no automático em 7 dias.',
      subtitle: 'Teste todas as funcionalidades para automatizar sua loja, crescer e lucrar mais.',
      ctaText: 'Testar grátis por 7 dias',
      imageSrc: 'assets/airton_access_7days.svg'
    },
    variantB: {
      title: 'Que tal testar antes de ir embora?',
      subtitle: 'Libere agora seu acesso completo por 7 dias. É 100% grátis e sem pedir cartão!',
      ctaText: 'Liberar acesso por 7 dias',
      imageSrc: 'assets/icon_access_7days.svg'
    }
  };

  get currentVariant(): MiddlewareExitIntentModalVariant {
    return this.variants[this.variant];
  }

  protected handleVisibilityChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
    
    if (!visible) {
      this.onDismiss.emit();
    }
  }

  protected handleAccept(): void {
    this.onAccept.emit();
    this.visible = false;
    this.visibleChange.emit(false);
    this.cdr.markForCheck();
  }
}
